module.exports = __webpack_public_path__ + "static/media/search-active.a3c60b15.svg";